import React from 'react';
import cx from 'classnames';
import styles from './loading-skeleton.module.css';

type SkeletonProps = Pick<
  React.CSSProperties,
  'width' | 'height' | 'borderRadius' | 'padding' | 'marginTop'
> & {
  /**
   * `contrast` darkens the bar and slows the shimmer for use on tinted cards,
   * where the default grey is too light to read.
   */
  variant?: 'default' | 'contrast';
};

export const LoadingSkeleton = ({
  width = '100%',
  height = 16,
  marginTop = 10,
  borderRadius = 24,
  padding = 0,
  variant = 'default',
}: SkeletonProps) => (
  <div
    style={{ width, height, marginTop, padding }}
    aria-hidden
    className={styles.Skeleton}
  >
    <div
      style={{ borderRadius }}
      className={cx(styles.SkeletonItem, {
        [styles.Contrast]: variant === 'contrast',
      })}
    />
  </div>
);
